import { render, staticRenderFns } from "./user-baseinfo.vue?vue&type=template&id=2e6a4b80&scoped=true&"
import script from "./user-baseinfo.vue?vue&type=script&lang=js&"
export * from "./user-baseinfo.vue?vue&type=script&lang=js&"
import style0 from "./user-baseinfo.vue?vue&type=style&index=0&id=2e6a4b80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6a4b80",
  null
  
)

export default component.exports